import { render, staticRenderFns } from "./SwiperImage3.vue?vue&type=template&id=686aaa8a&scoped=true&"
import script from "./SwiperImage3.vue?vue&type=script&lang=js&"
export * from "./SwiperImage3.vue?vue&type=script&lang=js&"
import style0 from "./SwiperImage3.vue?vue&type=style&index=0&id=686aaa8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686aaa8a",
  null
  
)

export default component.exports